export class PickupAction {
    constructor(parentUid, params = {}, description) {
        this.parentUid = parentUid;
        this.params = params;
        this.description = description;
        this.action = PickupAction.typestatic;
    }
    static is(params) {
        return params.action === PickupAction.typestatic;
    }
}
PickupAction.typestatic = "PickupAction";
